/**
 * Appends a classic `<script>` to `<head>` and resolves when it loads.
 *
 * **Never set `crossorigin` on these third-party tags.** Doing so turns an ordinary no-CORS
 * script load into a CORS request, and the browser then rejects any response that lacks
 * `Access-Control-Allow-Origin` — which is exactly how Meta serves `fbevents.js` and X serves
 * `uwt.js`. The failure reads as `net::ERR_FAILED 200 (OK)`: the fetch succeeded, the CORS check
 * did not. The attribute only buys subresource integrity and detailed `window.onerror` messages,
 * neither of which applies to vendor scripts we cannot pin a hash for.
 */
export function loadScript(document:Document,src:string):Promise<void>{
	return new Promise<void>((resolve,reject)=>{
		const script=document.createElement('script');
		script.src=src;
		script.async=true;
		script.addEventListener('load',():void=>resolve());
		script.addEventListener('error',():void=>reject(new Error(`Failed to load ${src}`)));
		document.head.appendChild(script);
	});
}
